import React, { useState } from 'react';
import { Box, Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import plusIcon from '../../../../Assets/images/plus-circle.svg';
import minusIcon from '../../../../Assets/images/minus-circle.svg';
import routes from '../../../../Utils/routes';

const faqData = [
  {
    question: 'What is Ideabaaz?',
    answer:
      "Ideabaaz is more than a show. It’s a national platform to help Indian founders bring their ideas to life with funding, mentorship, and exposure. If you're building something that solves what India truly needs today, Ideabaaz is where it begins. Idea aapka, paisa humara!",
  },
  // {
  //   question: 'What is Dangal?',
  //   points: [
  //     'If you’re building a growth startup that solves real, everyday problems in India: Apply to Ideabaaz.',
  //     'If you’re working on IP-led deep tech with at least an MVP, Project 47 is your path',
  //     'If you have a big idea that’s still in the concept stage, pitch it through Dangal.',
  //   ],
  // },
  {
    question: 'How do I apply?',
    points: [
      <>
        If you're building a growth startup that solves real, everyday problem in India: Apply to{' '}
        <Typography component="span" sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }} onClick={() => window.open(routes.signup)}>
          Ideabaaz.
        </Typography>
      </>,
      <>
        If you're working on IP-led deep tech with at least an MVP,
        <Typography component="span" sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }} onClick={() => window.open('https://project47.ideabaaz.co.in')}>
          Project 47
        </Typography>
        is your path.
      </>,
      <>
        If you have a big idea that's still in the concept stage, pitch it through{' '}
        <Typography component="span" sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: '700' }} onClick={() => window.open('https://www.ideabaazdangal.com/register')}>
          Dangal.
        </Typography>
      </>,
    ],
  },
  {
    question: 'Is funding guaranteed?',
    answer: 'All startups will be vetted by our internal selection teams. Funding is determined by investor interest during the pitch, but the platform offers far more than capital.',
  },
  {
    question: 'Who are the investors?',
    answer: 'You’ll meet seasoned investors, operators, and domain experts who understand what it takes to scale in your space. These are serious backers looking for serious founders.',
  },
];

const FAQSection = () => {
  const classes = useStyles();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Box className={classes.sectionMob}>
      {isMobile && (
        <Box sx={{ width: '90%', display: 'flex', flexDirection: 'column', margin: '0 auto' }}>
          <Typography className={classes.heading}>FAQs</Typography>
          <Typography className={classes.subheading}>This Is India’s moment. Be part of it.</Typography>
        </Box>
      )}

      <Box className={classes.section}>
        <Box className={classes.content}>
          {!isMobile && (
            <>
              <Typography className={classes.heading}>FAQs</Typography>
              <Typography className={classes.subheading}>This Is India’s moment. Be part of it.</Typography>
            </>
          )}

          <Box className={classes.faqList}>
            {faqData.map((item, index) => (
              <Box key={index} className={classes.faqItem}>
                <Box className={classes.questionRow} onClick={() => toggleIndex(index)}>
                  <Typography variant="h2" className={classes.question}>
                    {item.question}
                  </Typography>
                  <IconButton className={classes.iconBtn}>
                    <img src={openIndex === index ? minusIcon : plusIcon} alt={openIndex === index ? 'Collapse' : 'Expand'} className={classes.iconImage} />
                  </IconButton>
                </Box>
                {item.answer && openIndex === index && <Typography className={classes.answer}>{item.answer}</Typography>}
                {item.points &&
                  openIndex === index &&
                  item.points.map((point, idx) => (
                    <Box key={idx}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '1vh', marginTop: '1vh', '@media (max-width : 786px)': { alignItems: 'start' } }}>
                        <FiberManualRecordIcon sx={{ fontSize: '1vh' }} /> {point}
                      </Box>
                    </Box>
                  ))}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FAQSection;
